export default __webpack_public_path__ + "static/media/me.3f5194dd.jpg";